/**
 * Input Component
 *
 * Text input field with label and error handling.
 */

import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  fullWidth?: boolean;
}

export const Input: React.FC<InputProps> = ({
  label,
  error,
  fullWidth = false,
  style,
  ...props
}) => {
  const containerStyles: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    width: fullWidth ? '100%' : 'auto',
  };

  const labelStyles: React.CSSProperties = {
    fontSize: '14px',
    fontWeight: 500,
    color: '#5f6368',
  };

  const inputStyles: React.CSSProperties = {
    padding: '12px',
    fontSize: '16px',
    border: error ? '2px solid #ea4335' : '1px solid #dadce0',
    borderRadius: '8px',
    outline: 'none',
    transition: 'border-color 0.2s',
    ...style,
  };

  const errorStyles: React.CSSProperties = {
    fontSize: '13px',
    color: '#ea4335',
  };

  return (
    <div style={containerStyles}>
      {label && <label style={labelStyles}>{label}</label>}
      <input style={inputStyles} {...props} />
      {error && <span style={errorStyles}>{error}</span>}
    </div>
  );
};
